import { call, put, select } from 'redux-saga/effects';

import { selectDependentFormRole } from '../selectors';
import {
  DEPENDENT_FORM_STEPS,
  dependentFormActions,
} from '../progress.actions';
import {
  redirectToDocuments,
  redirectToGeneralInfo,
  redirectToRelation,
  redirectToRole,
} from './redirect-saga';
import { selectGuardianDependentById } from '../../profiles/selectors';

const stepsToCheck = [
  {
    step: DEPENDENT_FORM_STEPS.DOCUMENTS,
    cb: redirectToRelation,
  },
  {
    step: DEPENDENT_FORM_STEPS.GENERAL,
    cb: redirectToDocuments,
  },
  {
    step: DEPENDENT_FORM_STEPS.PERSONAL,
    cb: redirectToGeneralInfo,
  },
];

export function* validateDependentFormProgress({ payload: { id } }) {
  const role = yield select(selectDependentFormRole);
  const dependent = yield select(selectGuardianDependentById(Number(id)));

  if (id && id !== 'new' && dependent) {
    yield put(dependentFormActions.updateDependent(dependent));
    /** Check actual step to redirect */
    for (let i = 0; i < stepsToCheck.length; i++) {
      const current = stepsToCheck[i];
      if (dependent.registrationSteps[current.step]) {
        yield call(current.cb, dependent.id);
        break;
      }
    }
  } else if (!role) {
    yield call(redirectToRole);
  }

  yield put(dependentFormActions.finishValidate());
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/validate-steps-saga.js